<div class="fido">
  <div class="title">
    <h1>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.FIDO2.TITLE" | translate }}
    </h1>
    <p>
      {{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.FIDO2.SUB_TITLE" | translate }}
    </p>
  </div>
  <div class="fido-content">
    <div class="icon">
      <div
        class="circle-ripple"
        [ngClass]="{
          error: (errorState$ | async)?.message,
          success: (successState$ | async)?.ph_id
        }"
      >
        <span class="cidaas-icon-fido2"></span>
      </div>
    </div>
    <div class="status">
      <span class="error" *ngIf="(errorState$ | async)?.message">{{
        (errorState$ | async)?.message
      }}</span>

      <span class="success" *ngIf="(successState$ | async)?.ph_id"
        >{{ "SUGGESTED_VERIFICATION_METHOD.ENROLLMENT.FIDO2.SUCCESS" | translate }}</span
      >
    </div>
  </div>

  <ng-container *ngIf="(successState$ | async)?.ph_id">
    <cid-friendly-name [enrolledStatus]="successState$ |async" [track_id]="track_id" [method]="'fido2'" (enrolledState)="_fidoEnrollmentStatus($event)" style="width:100%;"></cid-friendly-name>
  </ng-container>

  <ng-container *ngIf="(errorState$ | async)?.message">
    <span style="padding: 1.5rem 0">
      <a
        *ngIf="(errorState$ | async)?.message"
        (click)="_cancelFidoEnrolment()"
        >{{ "Back" | translate }}</a
      ></span
    >
  </ng-container>
</div>

<!-- template for the error state -->
<ng-template #error>
  <span class="error">{{ (errorState$ | async)?.message }}</span>
</ng-template>
